module.exports = __webpack_public_path__ + "static/img/computer.952e06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/software/images/computer.png
// module id = Ymr7
// module chunks = 1